// Both Databricks and dbt Cloud sign in through Azure AD. Appending the
// signed-in user's UPN as `login_hint` makes their SSO flow default to the
// same account the user is signed into Prism with, so following one of these
// links logs them in as that user rather than prompting for account selection.
//
// This is a hint only -- if a different account already has an active session
// on the target, Microsoft may still prompt to confirm/switch.
export function withLoginHint(url: string, loginHint: string | null): string {
  if (!loginHint || !loginHint.trim()) return url
  try {
    const u = new URL(url)
    u.searchParams.set('login_hint', loginHint.trim())
    return u.toString()
  } catch {
    // Not an absolute URL we can parse -- leave it untouched.
    return url
  }
}
